export default __webpack_public_path__ + "static/media/cap.6635e1d2.png";